import React, { useContext } from "react";
import { AuthContext } from "../Context/context";

export const PermissionsGate = ({ children, permission }) => {
  const {currentUser}=useContext(AuthContext);
  
  return currentUser && currentUser?.permission.includes(permission) ? children : <></>;

};
